module.exports = __webpack_public_path__ + "img/36.1e4eabac.jpg";